module.exports = __webpack_public_path__ + "img/如何保存图、PDF.49971c21.gif";